import { Box, Button, Divider, Grid, IconButton, InputAdornment, Menu, MenuItem, OutlinedInput, Paper, Select, Table, TableBody, TableCell, TableContainer, TableFooter, TableHead, TableRow, TextField, Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'
import PrimaryDatePicker from '../../../PrimaryDatePicker'
import { DateTimePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs, { Dayjs } from 'dayjs';
import axios from 'axios';
import { toast } from 'react-toastify';
import { Add, ArrowBack, Clear, Delete, Done, KeyboardArrowDown, Print, Search } from '@mui/icons-material';
import TestNameModal from './TestNameModal';
import { useNavigate, useParams } from 'react-router-dom';
import SelectAssetsModal from './SelectAssetsModal';
import { TTestAsset } from '../../../../types';
import { findByText } from '@testing-library/react';
interface TestSelectionProps {
  patientId: string;
  pageClose: () => void;
  closeAllScreen: () => void;

}
const TestSelection: React.FC<TestSelectionProps> = ({ patientId, pageClose, closeAllScreen }) => {
  const navigate = useNavigate();
  const param = useParams();
  const paramId = param.id;
  const [storeSampleData, setStoreSampleDate] = useState<Date | null>(null);
  const [storeDateTime, setStoreDateTime] = useState<Date | null>(null);
  const [testCode, setTestCode] = useState<string>('');
  const [testName, setTestName] = useState<string>('');
  const [collectionType, setCollectionType] = useState<string>('0');
  const [specimen, setSpecimen] = useState<any>([]);
  const [tests, setTests] = useState<any>([]);
  const [nameTests, setNameTests] = useState<any>([]);
  const [openModal, setOpenModal] = useState(false);
  const [discountPercentage, setDiscountPercentage] = useState(0);
  const [discountInRs, setDiscountInRs] = useState(0);
  const [netAmount, setNetAmount] = useState(0);
  const [errors, setErrors] = useState({ collectionType: '', tests: '' });
  const [openAssetsModal, setOpenAssetsModal] = useState(false);
  const [assetsForTest, setAssetsForTest] = useState<TTestAsset[]>([]);
  const [searchedData, setSearchedData] = useState<TTestAsset[]>([]);
  const [searchQuery, setSearchQuery] = useState<string>('');
  const [quantities, setQuantities] = useState<any>([]);
  const [removeQuery, setRemoveQuery] = useState(false);
  const [saveQuantities, setSaveQuantities] = useState<any>([]);
  const [disabledAssets, setDisabledAssets] = useState<any>([]);
  const [assetId, setAssetId] = useState('');
  const [updateData, setUpdateData] = useState<any>({});
  const handleIncrement = (index: number) => {
    // console.log(quantities);
    if (removeQuery) {

      const updatedDataArray = searchedData?.map((item: any) => {
        if (item.index === index) {
          // If the id matches, update the quantity
          return { ...item, quantity: item.quantity + 1 };

        }
        // If the id doesn't match, return the original item
        return item;
      });

      setSearchedData(updatedDataArray);
    }
    let updatedQuantities: any = [...quantities];
    let getDisabledItems: any = [...disabledAssets];
    let findIndex = getDisabledItems.findIndex((item: any) => item?.assetName === updatedQuantities[index]?.assetName);
    let fetchRemaining: any = getDisabledItems[findIndex]?.remainings;
    console.log('fetch remainings', fetchRemaining);


    // if(getDisabledItems[findIndex] && fetchRemaining !== 0)
    // {
    // getDisabledItems[findIndex]['incrementDisabled']  = fetchRemaining - (updatedQuantities[index].quantity + 1) === 0 || getDisabledItems[findIndex]?.remainings <= 0  ? true : false;
    // getDisabledItems[findIndex]['decrementDisabled'] = updatedQuantities[index].quantity > 0 ? false : true;
    // getDisabledItems[findIndex]['remainings'] = fetchRemaining - 1
    // updatedQuantities[index].remainings = fetchRemaining - 1;
    // setDisabledAssets(getDisabledItems);
    updatedQuantities[index].quantity++;
    setQuantities(updatedQuantities);
    handleSaveQuantities(updatedQuantities);
    // }
    // console.log('updated quantities:',updatedQuantities);

  };

  const handleDecrement = (index: number) => {
    if (removeQuery) {

      const updatedDataArray = searchedData?.map((item: any) => {
        if (item.index === index) {
          // If the id matches, update the quantity
          return { ...item, quantity: item.quantity + 1 };

        }
        // If the id doesn't match, return the original item
        return item;
      });

      setSearchedData(updatedDataArray);

    }
    const updatedQuantities = [...quantities];
    let getDisabledItems: any = [...disabledAssets];
    let findIndex = getDisabledItems.findIndex((item: any) => item?.assetName === updatedQuantities[index]?.assetName);
    let fetchRemaining: any = getDisabledItems[findIndex]?.remainings;




    // if(getDisabledItems[findIndex])
    // {
    // getDisabledItems[findIndex]['incrementDisabled']  = fetchRemaining - (updatedQuantities[index].quantity + 1) === 0 || getDisabledItems[findIndex]?.remainings <= 0  ? true : false;
    // getDisabledItems[findIndex]['decrementDisabled'] = updatedQuantities[index].quantity > 0 ? false : true;
    // getDisabledItems[findIndex]['remainings'] = fetchRemaining + 1
    // updatedQuantities[index].remainings = fetchRemaining + 1
    // console.log('getDisabledItems',getDisabledItems);
    // setDisabledAssets(getDisabledItems);
    // if (updatedQuantities[index].quantity > 0) {
    updatedQuantities[index].quantity--;
    setQuantities(updatedQuantities);
    // }

    handleSaveQuantities(updatedQuantities);
    // }


  };
  const handleSaveQuantities = (qn: any, testId?: string) => {
    // console.log('qn',qn)
    let id = assetId;
    if (testId) {

      id = testId;
    }
    //  console.log('testId',testId);
    let getSavedQuantities: any = saveQuantities;
    let getIndex = saveQuantities.findIndex((item: any) => item.id === id);
    if (getIndex !== -1) {

      getSavedQuantities.splice(getIndex, 1);
    }
    let data = { id, qn };
    // console.log('data',data);
    getSavedQuantities.push(data);

    setSaveQuantities(getSavedQuantities);

  }
  const handleCloseAssetsModal = () => {
    setOpenAssetsModal(false);
  }
  const searchAssets = (searchQuery: string) => {
    searchQuery = searchQuery.toLowerCase();
    let filterSearchData: any = quantities.map((item: any, index: any) => {
      if (item.assetName.toLowerCase().includes(searchQuery)) {
        return { assetName: item.assetName, id: item.id, index, quantity: item.quantity, remainings: item?.remainings }
      } else {
        return false;
      }
    });
    filterSearchData = filterSearchData.filter((item: any) => item !== false);
    // console.log('filterSearchData',filterSearchData);
    setSearchedData(filterSearchData);
  }
  const handleSampleDate = (date: Date | null) => {
    setStoreSampleDate(date);
    // setStartAutoUpdate(false);
    // setSelectedAppointmentDate(date);

    // // event?.target?.value ? :
    // getAppointments(!tabValue ? "active" : "checked", 1, rowsPerPage, selectedDoctor, date)

  };
  const handleReportingDate = (date: Date | null) => {
    setStoreDateTime(date);
  }
  const handleCloseModal = () => {
    setOpenModal(false);
  };
  const fetchAssetsForTest = () => {
    let config = {
      method: 'get',
      maxBodyLength: Infinity,
      url: `${process.env.REACT_APP_PATHOLOGY_URL}/assets/getAllAssetsUserForTests`,
      headers: {
        'accept': '*/*',
        'Authorization': `Bearer ${localStorage.getItem('token')}`
      }
    };

    axios.request(config)
      .then((response) => {
        if (response?.data?.isSuccess) {
          setAssetsForTest(response?.data?.data);
          setQuantities(response?.data?.data.map((asset: any) => ({ id: asset?._id, assetName: asset.assetName, quantity: 0, remaining: asset?.remainings })));
          setDisabledAssets(response?.data?.data.map((asset: any) => ({ id: asset?._id, assetName: asset.assetName, incrementDisabled: asset?.remainings > 0 ? false : true, decrementDisabled: asset?.remainings > 0 ? false : true, remainings: asset?.remainings })))
          if (paramId) {
            fetchDataForUpdate(response?.data?.data);
          }

        } else {
          toast.error(response?.data?.message);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }
  const fetchDataForUpdate = (assetsData: any) => {
    if (paramId) {

      let config = {
        method: 'get',
        maxBodyLength: Infinity,
        url: `${process.env.REACT_APP_PATHOLOGY_URL}/lab-link/getOnePatientLabById/${paramId}`,
        headers: {
          'accept': '*/*',
          'Authorization': `Bearer ${localStorage.getItem('token')}`
        }
      };

      axios.request(config)
        .then((response) => {
          if (response?.data?.isSuccess) {
            const patientLabData = response?.data?.data;
            setStoreDateTime(patientLabData?.dateOFReporting);

            setStoreSampleDate(patientLabData?.dateOFSample);
            setCollectionType(patientLabData?.specimenCollectionType);
            setDiscountInRs(patientLabData?.discountRS);
            setNetAmount(patientLabData?.totalCost);


            const discountPercentage = calculateDiscountPercentage(patientLabData?.totalRevenue, (patientLabData?.totalRevenue - patientLabData?.discountRS));
            let updatedTests: any = [];

            patientLabData?.labTestData?.map((item: any) => {
              updatedTests.push(item)
            })

            patientLabData?.labTests?.map((item: any) => {
              let mapQuantitiesArray: any = [];
              item?.requiredAssets?.map((item2: any) => {
                let fetchSavedQuantites = [...saveQuantities];
                let fetchDisabledAssets = [...disabledAssets];

                let fetchAssets = assetsData?.filter((item3: any) => item3?._id === item2?.assetId);

                let mapQuantitiesData = {
                  id: fetchAssets[0]?._id,
                  assetName: fetchAssets[0]?.assetName,
                  quantity: item2?.requiredQuantity,
                  remaining: 0
                }
                let newMapData = assetsData?.map((item3: any) => {
                  if (item3?._id === fetchAssets[0]?._id) {
                    return {
                      id: item3?._id,
                      assetName: item3?.assetName,
                      quantity: item2?.requiredQuantity,
                      remaining: item3?.remainings
                    }
                  }
                  //   else{
                  // //  if(newMapData?.findIndex((item4:any)=>item4?.id === item3?._id) !== -1){
                  // //   console.log('testing',item3)
                  //   return  {
                  //     id: item3?._id,
                  //     assetName: item3?.assetName,
                  //     quantity: 0,
                  //     remaining: item3?.remainings
                  // }
                  // //  }
                  //   }
                })

                mapQuantitiesArray.push(newMapData?.filter((item4: any) => item4 !== undefined)?.[0]);

                //  console.log('mapQuantitiesArray',mapQuantitiesArray);
                let fetchDisabledAssetsIndex = disabledAssets?.findIndex((item3: any) => item3?.id === item2?.assetId);
                // fetchAssets[fetchAssetsIndex] = 
              })
              mapQuantitiesArray?.map((item: any) => {
                assetsData?.map((item2: any) => {
                  if (item?.id !== item2?._id) {
                    mapQuantitiesArray?.push({
                      id: item2?._id,
                      assetName: item2?.assetName,
                      quantity: 0,
                      remaining: item2?.remainings
                    })
                  }
                })
              })
              const uniqueData = mapQuantitiesArray.reduce((acc: any, current: any) => {
                const x = acc.find((item: any) => item.id === current.id);
                if (!x) {
                  return acc.concat([current]);
                } else {
                  return acc;
                }
              }, []);
              handleSaveQuantities(uniqueData, item?.testId);
            })

            setTests(updatedTests)
            setDiscountPercentage(discountPercentage ? discountPercentage : 0);
            setUpdateData(patientLabData);
          } else {
            toast.error('Patient Lab data is not found! ');
            navigate('/patient-registration-and-test-entry');
          }
        })
        .catch((error) => {

          // navigate('/patient-registration-and-test-entry');
        });
    }
  }
  const calculateDiscountPercentage = (originalCost: number, costWithDiscount: number): number => {
    const discount = originalCost - costWithDiscount;

    const discountPercentage = (discount / originalCost) * 100;
    return discountPercentage;
  };
  useEffect(() => {

    fetchAssetsForTest();
    fetchSpecimenType();

  }, [])
  const fetchSpecimenType = () => {
    let config = {
      method: 'get',
      maxBodyLength: Infinity,
      url: `${process.env.REACT_APP_PATHOLOGY_URL}/specimen-type`,
      headers: {
        'accept': '*/*',
        'Authorization': `Bearer ${localStorage.getItem('token')}`
      }
    };

    axios.request(config)
      .then((response) => {
        if (response?.data?.isSuccess) {
          setSpecimen(response?.data?.data);
        } else {
          toast.error(response?.data?.message);
        }
      })
      .catch((error) => {
      });
  }
  const fetchTests = (modaldata: string | null = null) => {
    setErrors({ collectionType: '', tests: '' });

    let query = '';
    let type = 'code';
    if (testCode) {
      query = testCode;
    } else {
      if (testName) {
        type = 'name';
        query = testName;
      } else if (modaldata) {
        query = modaldata;
        type = 'modal';
      }
      else {
        toast.error('Please type test code or test name to add test!')
        return false;
      }
    }
    let config = {
      method: 'get',
      maxBodyLength: Infinity,
      url: `${process.env.REACT_APP_PATHOLOGY_URL}/test/getAllTests?search=${query}`,
      headers: {
        'accept': '*/*',
        'Authorization': `Bearer ${localStorage.getItem('token')}`
      }
    };

    axios.request(config)
      .then((response) => {
        if (response?.data?.isSuccess) {
          if (response?.data?.data.length > 0) {
            if (type === 'code' || type === 'modal') {
              let singleTest = [...tests];
              let findTestIndex = singleTest?.findIndex((item: any) => item?._id === response?.data?.data[0]?._id);
              if (findTestIndex === -1) {
                singleTest.push(response?.data?.data[0]);
                setTests(singleTest);
              }

            }
            if (type === 'name') {
              setNameTests(response?.data?.data);
              setOpenModal(true);
            }
          } else {
            toast.error('No record found!')
          }
        } else {
          toast.error('No record found!')
        }

      })
      .catch((error) => {
      }).finally(() => {
        setTestCode('');
        setTestName('');
        if (type === 'modal') {
          setOpenModal(false);
        }
      });

  }
  const handleDiscount = (e: any) => {
    let value: any = parseInt(e.target.value);

    // Ensure the value is not less than 0

    if (value < 0) {
      value = 0;
    }
    // Ensure the value is not more than 100
    if (value > 100) {
      value = 100;
    }
    setDiscountPercentage(value)
    if (!value) {
      value = 0;
      setNetAmount(0)
    }

    let total: any = tests.reduce((acc: number, report: any) => acc + report.cost, 0);
    let marginCost: any = tests.reduce((acc: number, report: any) => acc + report.revenue, 0);
    total = parseInt(total);

    const discountAmount = (marginCost * value) / 100;
    const netCost = total - discountAmount;
    setNetAmount(netCost);
    setDiscountInRs(discountAmount);

  }
  const handleSubmit = () => {
    setErrors({ collectionType: '', tests: '' });
    if (collectionType === '0') {
      setErrors({ ...errors, collectionType: 'Select a Specimen Collection Type!' })
      return false;
    }
    if (tests.length < 1) {

      setErrors({ ...errors, tests: 'Please add a test' });
      toast.error('Please add a test');
      return false;
    }
    let testIds = tests.map((item: any, index: any) => {
      return item?._id;
    })
    let totalCost = tests.reduce((acc: number, report: any) => acc + report.cost, 0);
    let totalExpenses = tests.reduce((acc: number, report: any) => acc + report.expenses, 0);
    let totalRevenue = tests.reduce((acc: number, report: any) => acc + report.revenue, 0);
    let sampleDate: any = storeSampleData;
    let reportingDate: any = storeDateTime;
    let labTests: any = [];
    tests?.map((item: any) => {
      let obj: any = {
        testId: item?._id,
        // requiredAssets:[]
      };
      //      let requiredAssets:any = [];

      //      item?.qn?.map((item2:any)=>{
      //    if(item2?.quantity)
      //    {
      //     let newData =  
      //     {
      //       "assetId": item2?.id,
      //       "requiredQuantity": item2?.quantity
      //     }


      // requiredAssets.push(newData);
      //    }

      //      })
      //      obj.requiredAssets = requiredAssets;
      labTests.push(obj);
    })

    let data = {

      "patientId": patientId,
      "specimenCollectionType": collectionType,
      "dateOFSample": sampleDate ? dayjs(sampleDate).format('YYYY-MM-DD') : dayjs().format('YYYY-MM-DD'),
      "dateOFReporting": reportingDate ? dayjs(reportingDate).format('YYYY-MM-DD') : dayjs().format('YYYY-MM-DD'),
      "labTests": labTests,
      "totalCost": parseInt(totalCost),
      "discountRS": discountInRs,
      totalExpenses: parseInt(totalExpenses),
      totalRevenue: parseInt(totalRevenue)

    };

    let config = {
      method: 'post',
      maxBodyLength: Infinity,
      url: `${process.env.REACT_APP_PATHOLOGY_URL}/lab-link/addPatientForLab`,
      headers: {
        'accept': '*/*',
        'Authorization': `Bearer ${localStorage.getItem('token')}`,
        'Content-Type': 'application/json'
      },
      data: data
    };

    axios.request(config)
      .then((response) => {
        if (response?.data?.isSuccess) {
          toast.success(response?.data?.message);
          closeAllScreen();
        } else {
          toast.error(response?.data?.message);
        }
      })
      .catch((error) => {
        toast.error(error?.response?.data?.message[0]);
      });

  }
  const handleSubmitUpdate = () => {
    let totalCost = tests.reduce((acc: number, report: any) => acc + report.cost, 0);
    let totalExpenses = tests.reduce((acc: number, report: any) => acc + report.expenses, 0);
    let totalRevenue = tests.reduce((acc: number, report: any) => acc + report.revenue, 0);
    let labTests: any = [];
    saveQuantities?.map((item: any) => {
      let obj: any = {
        testId: item?.id,
        requiredAssets: []
      };
      let requiredAssets: any = [];

      item?.qn?.map((item2: any) => {
        if (item2?.quantity) {
          let newData =
          {
            "assetId": item2?.id,
            "requiredQuantity": item2?.quantity
          }


          requiredAssets.push(newData);
        }

      })
      obj.requiredAssets = requiredAssets;
      labTests.push(obj);
    })
    let data = JSON.stringify({
      "mrn": updateData?.mrn,
      "patientId": updateData?.patientId,
      "specimenCollectionType": collectionType,
      "dateOFSample": storeSampleData,
      "dateOFReporting": storeDateTime,
      "labTests": labTests,
      "totalCost": parseInt(totalCost),
      "discountRS": discountInRs,
      "totalExpenses": parseInt(totalExpenses),
      "totalRevenue": parseInt(totalRevenue)
    });

    let config = {
      method: 'put',
      maxBodyLength: Infinity,
      url: `${process.env.REACT_APP_PATHOLOGY_URL}/lab-link/updateLablinkById/${paramId}`,
      headers: {
        'accept': '*/*',
        'Authorization': `Bearer ${localStorage.getItem('token')}`,
        'Content-Type': 'application/json'
      },
      data: data
    };

    axios.request(config)
      .then((response) => {
        if (response?.data?.isSuccess) {
          toast?.success(response?.data?.message);
        } else {
          toast.error(response?.data?.message);
        }
      })
      .catch((error) => {
        console.log(error);
      }).finally(() => {
        navigate('/patient-registration-and-test-entry');
      });
  }

  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleAssetClick = (event: any, id: string) => {
    // console.log('saveQuantities',saveQuantities)
    setAssetId(id);
    // console.log('disabled Assets',disabledAssets);
    let checkSavedData = saveQuantities.find((item: any) => item.id === id);
    // console.log('checkSavedData',checkSavedData)
    if (checkSavedData) {
      setQuantities(checkSavedData.qn);

    } else {
      setQuantities(disabledAssets?.map((asset: any) => ({ id: asset?.id, assetName: asset.assetName, quantity: 0, remaining: asset?.remainings })));


    }
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };
  const handleDeleteTest = (index: number, id: string) => {
    let getTests: any = [...tests];
    getTests.splice(index, 1);
    let getSavedQuantities: any = [...saveQuantities]
    let getIndex = saveQuantities.findIndex((item: any) => item.id === id);
    let getDisabledItems: any = [...disabledAssets];
    let getRemovedData = getSavedQuantities[getIndex];


    getRemovedData?.qn?.map((item: any) => {

      let findIndexOfDisabled = getDisabledItems.findIndex((item2: any) => item2?.id === item?.id);

      getDisabledItems[findIndexOfDisabled]['remainings'] = getDisabledItems[findIndexOfDisabled]?.remainings + item?.quantity;
    })

    setDisabledAssets(getDisabledItems);
    if (getIndex !== -1) {

      getSavedQuantities.splice(getIndex, 1);
    }
    setSaveQuantities(getSavedQuantities);
    setTests(getTests);
  }
  const handleRemove = () => {
    setSearchQuery('');
    searchAssets('');
    setRemoveQuery(false);
  }
  const handleSearch = () => {
    searchAssets(searchQuery);
    setRemoveQuery(true);
  }
  const changeAssetValue = (index: number, value: string) => {
    let updatedQuantities: any = [...quantities];

    updatedQuantities[index].quantity = parseInt(value);
    // console.log('updated quantities',updatedQuantities)
    setQuantities(updatedQuantities);
    handleSaveQuantities(updatedQuantities);
  }
  return (
    <div> <Box sx={{ background: '#fff', p: 2, mb: 2, borderRadius: '12px' }}>
      <TestNameModal open={openModal} handleClose={handleCloseModal} data={nameTests} setTests={fetchTests} />
      <Box display='flex' justifyContent='space-between' alignItems='center'>
        <Typography sx={{ color: '#000', fontSize: '24px', fontWeight: '600', textTransform: 'capitalize' }}>Test Selection</Typography>

      </Box>
    </Box>
      <Box sx={{ background: '#fff', p: 2, mb: 2, borderRadius: '12px' }}>
        <Box mt={2} >
          <Grid container >
            <Grid item xs={6} md={5} lg={3} >
              <PrimaryDatePicker onChange={handleSampleDate} changeValue={storeSampleData} label='Sample Date' />
            </Grid>
            <Grid item xs={5} md={5} lg={3} sx={{ ml: 1 }}>
              <PrimaryDatePicker onChange={handleReportingDate} changeValue={storeDateTime} label='Reporting Date' />

            </Grid>
          </Grid>
          <Grid container alignItems="center" sx={{ mt: 2 }}>

            <Grid item md={1} xs={2}>
              <Typography sx={{ fontSize: { xs: '16px', md: '24px' }, fontWeight: 600 }}>Tests</Typography>
            </Grid>
            <Grid item md={11} xs={10}>
              <Divider sx={{ width: '100%' }} />

            </Grid>
          </Grid>
          <form>
            <div style={{ display: 'flex', alignItems: 'center', marginTop: '10px', flexWrap: 'wrap' }}>
              <Box>
                <Typography sx={{ fontSize: '14px', color: '#3F3F3F', fontWeight: '600' }}>Test Code :</Typography>
                <TextField
                  placeholder="Test Code"
                  variant="outlined"
                  value={testCode}
                  size='small'
                  type='number'
                  sx={{
                    '& input[type="number"]::-webkit-inner-spin-button, & input[type="number"]::-webkit-outer-spin-button': {
                      display: 'none'
                    }
                  }}
                  InputProps={{
                    style: {
                      borderRadius: "12px",
                      border: '1px solid #D8D8D8',
                      background: '#F5F5FB',
                      fontSize: '12px'
                    }
                  }}
                  onChange={(e) => setTestCode(e.target.value)}
                  style={{ marginRight: '1rem' }}
                />
              </Box>
              <Box>
                <Typography sx={{ fontSize: '14px', color: '#3F3F3F', fontWeight: '600' }}>Test Name :</Typography>
                <TextField
                  placeholder="Test Name"
                  variant="outlined"
                  value={testName}
                  size='small'
                  onChange={(e) => setTestName(e.target.value)}
                  style={{ marginRight: '1rem' }}
                  InputProps={{
                    style: {
                      borderRadius: "12px",
                      border: '1px solid #D8D8D8',
                      background: '#F5F5FB',
                      fontSize: '12px'
                    }
                  }}
                />
              </Box>

              <Box style={{ flex: 1, marginTop: '20px' }}>
                <Button variant="outlined" color="primary" onClick={() => fetchTests(null)}  >
                  Add Test
                </Button>

              </Box>


              <Box >
                <Typography sx={{ fontSize: '14px', color: '#3F3F3F', fontWeight: '600' }}>Specimen Collection Type :</Typography>
                <TextField
                  select
                  variant="outlined"
                  value={collectionType}
                  onChange={(e) => {
                    setErrors({ collectionType: '', tests: '' });
                    setCollectionType(e.target.value as string)
                  }}
                  style={{ minWidth: '200px' }}
                  size='small'
                  InputProps={{
                    style: {
                      borderRadius: "12px",
                      border: '1px solid #D8D8D8',
                      background: '#F5F5FB',
                      fontSize: '12px'
                    }
                  }}                >

                  <MenuItem value="0" disabled>
                    Select Specimen Collection Type
                  </MenuItem>
                  {specimen?.map((item: any) => {
                    return <MenuItem value={item?.name}>{item?.name}</MenuItem>
                  })}
                  {/* Add more options as needed */}
                </TextField>
                {errors?.collectionType ? <Typography sx={{ fontSize: '12px', color: 'error.main' }}>{errors?.collectionType}</Typography> : ''}
              </Box>

            </div>
          </form>
          <Box sx={{ mt: 2 }}>
            <TableContainer component={Paper} sx={{
              maxHeight: '35vh', overflow: 'auto', '&::-webkit-scrollbar': {
                width: '6px',

              },
              '&::-webkit-scrollbar-thumb': {

                backgroundColor: '#077DD3',


              }, '&::-webkit-scrollbar-track': {
                backgroundColor: 'rgba(7, 125, 211, 0.24)',


              },
            }} >
              <Table aria-label="test table" size="small">
                <TableHead sx={{ position: 'sticky', top: 0, zIndex: 1 }}>
                  <TableRow sx={{ background: '#077DD3' }}>
                    <TableCell sx={{ fontSize: { md: '0.8em', xs: '0.6em', xl: '0.8em', sm: '0.6em', lg: '0.8em' }, p: 1, color: 'white' }}>Test Code</TableCell>
                    <TableCell sx={{ fontSize: { md: '0.8em', xs: '0.6em', xl: '0.8em', sm: '0.6em', lg: '0.8em' }, p: 1, color: 'white' }}>Department</TableCell>
                    <TableCell sx={{ fontSize: { md: '0.8em', xs: '0.6em', xl: '0.8em', sm: '0.6em', lg: '0.8em' }, p: 1, color: 'white' }}>Test Name</TableCell>
                    <TableCell sx={{ fontSize: { md: '0.8em', xs: '0.6em', xl: '0.8em', sm: '0.6em', lg: '0.8em' }, p: 1, color: 'white' }}>Sample Required</TableCell>
                    {/* <TableCell sx={{ fontSize: { md: '0.8em', xs: '0.6em', xl: '0.8em', sm: '0.6em', lg: '0.8em' }, p: 1, color: 'white' }}>Assets</TableCell> */}
                    <TableCell sx={{ fontSize: { md: '0.8em', xs: '0.6em', xl: '0.8em', sm: '0.6em', lg: '0.8em' }, p: 1, color: 'white' }}>Charges</TableCell>
                    <TableCell sx={{ fontSize: { md: '0.8em', xs: '0.6em', xl: '0.8em', sm: '0.6em', lg: '0.8em' }, p: 1, color: 'white' }}>Action</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {/* Example row */}
                  {tests?.length > 0 ? tests?.map((item: any, index: any) => {
                    return <TableRow sx={{ '& > .MuiTableCell-root': { height: '20px' } }}>
                      <TableCell sx={{ fontSize: { md: '0.8em', xs: '0.6em', xl: '0.8em', sm: '0.6em', lg: '0.8em' }, p: 1 }}>{item?.testCode}</TableCell>
                      <TableCell sx={{ fontSize: { md: '0.8em', xs: '0.6em', xl: '0.8em', sm: '0.6em', lg: '0.8em' }, p: 1 }}>{item?.labDepartmentId?.labDepartmentName}</TableCell>
                      <TableCell sx={{ fontSize: { md: '0.8em', xs: '0.6em', xl: '0.8em', sm: '0.6em', lg: '0.8em' }, p: 1 }}>{item?.testName}</TableCell>
                      {/* <TableCell sx={{fontSize:{md:'0.8em',xs:'0.6em',xl:'0.8em',sm:'0.6em',lg:'0.8em'} ,p:1}}> */}
                      <TableCell sx={{ fontSize: { md: '0.8em', xs: '0.6em', xl: '0.8em', sm: '0.6em', lg: '0.8em' }, p: 1 }}>{item?.sampleRequired}</TableCell>
                      {/* <Select sx={{width:'100%', height: '35px',fontSize:'12px'}}>
                {sampleOptions.map((option:any) => (
                  <MenuItem key={option} value={option} sx={{fontSize:'12px'}}>{option}</MenuItem>
                ))}
              </Select> */}
                      {/* </TableCell> */}

                      <TableCell sx={{ fontSize: { md: '0.8em', xs: '0.6em', xl: '0.8em', sm: '0.6em', lg: '0.8em' }, p: 1 }}>{item?.cost}</TableCell>
                      <TableCell sx={{ fontSize: { md: '0.8em', xs: '0.6em', xl: '0.8em', sm: '0.6em', lg: '0.8em' }, p: 1 }}>
                        <Button sx={{ '&:hover': { background: 'none' } }} onClick={() => handleDeleteTest(index, item?._id)}><Delete sx={{ color: '#FF5454', minWidth: '20.09px', minHeight: '20.09px', height: 20.09, width: 29.09, '&:hover': { background: 'none', color: 'rgb(191, 44, 44)' } }} /></Button>
                        <Button sx={{ '&:hover': { background: 'none' } }}><Print sx={{ color: 'success.main', minWidth: '20.09px', minHeight: '20.09px', height: 20.09, width: 29.09, '&:hover': { background: 'none', color: 'rgb(109, 132, 3)' } }} /></Button>
                      </TableCell>
                    </TableRow>
                  }) : <TableRow><TableCell colSpan={7} sx={{ textAlign: 'center', fontWeight: '600', textTransform: 'capitalize', color: 'error.main' }}>No tests included yet</TableCell></TableRow>}
                </TableBody>
                <TableFooter sx={{ fontSize: { md: '0.6em', xs: '0.6em', xl: '0.8em', sm: '0.6em', lg: '0.8em' }, position: 'sticky', bottom: 0, zIndex: 1, background: 'white', height: '100%' }}>
                  <TableRow >
                    <TableCell colSpan={2} sx={{ fontSize: { md: '1em', xs: '0.8em', xl: '1em', sm: '0.8em', lg: '1em' }, p: 1 }}>Total Cost: {tests.length > 0 ? tests.reduce((acc: number, report: any) => acc + report.cost, 0).toLocaleString() : 0}</TableCell>
                    <TableCell colSpan={1} sx={{ fontSize: { md: '1em', xs: '0.8em', xl: '1em', sm: '0.8em', lg: '1em' }, p: 1 }}><Box display={'flex'} alignItems={'center'}>Discount %: <TextField value={discountPercentage} onChange={(e) => handleDiscount(e)} type='number' sx={{
                      width: '60px', '& .MuiInputBase-root': {
                        height: '35px',
                        fontSize: '12px',
                      },
                      '& .MuiOutlinedInput-root': {
                        height: '35px',
                        borderRadius: '12px',
                        border: '1px solid #D8D8D8',
                        backgroundColor: '#F5F5FB',
                      }, '& input[type="number"]::-webkit-inner-spin-button, & input[type="number"]::-webkit-outer-spin-button': {
                        display: 'none'
                      }
                    }} /></Box></TableCell>
                    <TableCell colSpan={1} sx={{ fontSize: { md: '1em', xs: '0.8em', xl: '1em', sm: '0.8em', lg: '1em' }, p: 1 }}>Discount Rs: {discountInRs}</TableCell>
                    <TableCell colSpan={1} sx={{ fontSize: { md: '1em', xs: '0.8em', xl: '1em', sm: '0.8em', lg: '1em' }, p: 1 }}>Net Amount: {netAmount ? netAmount : tests.reduce((acc: number, report: any) => acc + report.cost, 0).toLocaleString()}</TableCell>
                    <TableCell colSpan={1} sx={{ fontSize: { md: '1em', xs: '0.8em', xl: '1em', sm: '0.8em', lg: '1em' }, p: 1 }}>Now Paying: {netAmount ? netAmount : tests.reduce((acc: number, report: any) => acc + report.cost, 0).toLocaleString()}</TableCell>
                  </TableRow>
                </TableFooter>
              </Table>
            </TableContainer>
          </Box>
          <Box display={'flex'} justifyContent={'end'} sx={{ mt: 2 }}>
            <Button variant='outlined' startIcon={<ArrowBack />} onClick={() =>
              paramId ? navigate('/patient-registration-and-test-entry') : pageClose()
            }>Back</Button>
            {paramId ? <Button variant='contained' startIcon={<Done />} sx={{ ml: 1 }} onClick={handleSubmitUpdate}>Update</Button> : <Button variant='contained' startIcon={<Done />} sx={{ ml: 1 }} onClick={handleSubmit}>Save</Button>}
            <Button variant='contained' startIcon={<Print />} sx={{ ml: 1 }}>Print & Share</Button>
          </Box>
        </Box></Box>
      <SelectAssetsModal onClose={handleCloseAssetsModal} open={openAssetsModal} data={assetsForTest} searchAssets={searchAssets} />
    </div>
  )
}

export default TestSelection